export default __webpack_public_path__ + "media/images/avatars/avatar-a63e6b34b1ae1e043035f806f844117f.jpg";